import React from "react";
import "./PollGraph.scss";
import {MDBBox, MDBIcon, MDBProgress, MDBTypography} from "mdbreact";
import {withRouter} from "react-router-dom";
import {isNanHandler} from "../../util";
import {assetUrl} from "../../serviceApi";
import Login from "../../pages/Login/Login";
import {AddProfileData, setActivePage} from "../../Actions";
import {compose} from "redux";
import {connect} from "react-redux";

const BJP = assetUrl + "images/BJP.png";
const TMC = assetUrl + "images/TMC.png";
const INC = assetUrl + "images/INC.png";
const AAP = assetUrl + "images/aap_party_avatar.png";
const grant = assetUrl + 'images/icon_grant_blue.svg'
const PollStrip = assetUrl + "images/poll-strip.svg";

class PollGraph extends React.Component {

	state = {
		poll_result: [
			{
				title: "BJP",
				icon: BJP,
				percent: 30
			},
			{
				title: "AAP",
				icon: AAP,
				percent: 60

			},
			{
				title: "INC",
				icon: INC,
				percent: 50
			},
			{
				title: "TMC",
				icon: TMC,
				percent: 40
			}
		],
		selected_poll: "AAP",
		login_modal:false
	}

	handleSelectedPolls = (data) => {
		this.setState({
			selected_poll: data.title
		});
	}

	openLoginModal = () => {
		this.setState({
			login_modal:true
		});
	}
	closeLoginModal = () => {
		this.setState({
			login_modal:false
		});
	}
	completeLogin = () => {
		this.closeLoginModal();
		window.location.reload();
	}
	checkUserLoggedIn = () => {
		if(this.props.logged_in === false){
			this.openLoginModal();
		} else {
			this.props.history.push("/poll-result");
		}
	}

	render() {
		const {poll_data, quiz_participated, user_answer, submitPollResult, pollResult, pollChoices} = this.props;

		return (
			<>
				<MDBBox className="poll-graph-component">
					{poll_data &&
					<MDBBox className="poll-graph-section">
						<img src={PollStrip} alt="PollStrip" className="img-fluid poll-strip"/>
						<MDBTypography tag="p" className="poll-of-the-day">poll of the day</MDBTypography>
						<MDBTypography tag="p" className="poll-question">{poll_data.question}</MDBTypography>

						<MDBTypography tag="p" className="poll-description">Participate to get free coins!</MDBTypography>
						{
							quiz_participated === true ?

								<div>
									<PollGraphBar user_answer={user_answer} choices={pollChoices}/>
									{
										this.props.onboarding !== true &&
										<div className={"w-100"}>
											<div className={'d-flex justify-content-between align-items-center'}
												 style={{marginBottom: "26px"}}>
												<hr className={"grant-hr-left"}/>
												<div className={'d-flex align-items-center'} style={{whiteSpace: "nowrap"}}>
													<img src={grant} alt={"alt"} className={"grant-icon"}/>
													<p className={"grant-title text-center"}> {poll_data.reward} Bonus</p>
												</div>
												<hr className={"grant-hr-right"}/>
											</div>
											<p className={"grant-text text-center w-100"}>Congratulations!<br/>
												Thank you for your participation!</p>
										</div>
									}

								</div>
								:
								<PollList poll_result={poll_data}
										  handleSelectedPolls={submitPollResult}
										  openLoginModal={this.openLoginModal}
										  logged_in={this.props.logged_in}

								/>
						}
						{
							!pollResult &&
							<div className={`view-all-poll ${this.props.onboarding === true ? "text-left" : "text-center"}`}
								 onClick={this.checkUserLoggedIn}>View All
								Polls <MDBIcon icon="angle-right" className="ml-2"/>
							</div>
						}

					</MDBBox>}
				</MDBBox>
				<Login isOpen={this.state.login_modal}
					   closeModal={this.closeLoginModal}
					   completeLogin={this.completeLogin}
				/>
			</>
		);
	}
}

const mapStateToProps = state => ({
	logged_in: state.UserReducer.logged_in
})

export default compose(
	withRouter,
	connect(mapStateToProps, null)
)(PollGraph)


class PollGraphBar extends React.Component {
	render() {
		function setPrc(progress) {
			// if( progress && document.getElementById('progress') ) {
			//     // this is how to set the progress programmatically,
			//     // the background-position needs the inverted value from 0% to 100% (0% means full bar, 100% means empty)
			//     document.getElementById('progress').setAttribute( 'style', 'background-position: ' + (100-progress) + '% 0')
			// } else {
			//     document.getElementById('progress').setAttribute( 'style', '')
			// }
		}

		return (
			<MDBBox className="poll-bars">
				{
					// this.props.poll_result.poll && this.props.poll_result.poll.pollChoices && this.props.poll_result.poll.pollChoices.edges.map((item, index) => {
					this.props.choices && this.props.choices.length !== 0 && this.props.choices.map((item, index) => {

						setPrc(item.percent)
						let active
						let answerList = this.props.user_answer

						if (answerList.length > 0) {
							for (let i = 0; i < answerList.length; i++) {
								// debugger
								if(answerList[i].node.answer.id === item.node.id){
										active = true ;
										break
								}else{
										active = false ;
								}


							}

						}

						return (
							<MDBBox
								className={`d-flex  align-items-start justify-content-between ${active ? "active-poll" : ""}`}
								key={index}>
								<MDBProgress id={"progress "}
								             value={item.node.choicePercentage > 0 ? item.node.choicePercentage : 35}
								             className=" mr-2">
									<img src={item.node.icon ? item.node.icon : BJP} alt="BJP"
									     className="img-fluid bar-icon" width="20px" height={"20px"}/>
									<span style={item.node.choicePercentage < 20 ? {
										color: "#A1A1AB",
										marginLeft: "8px",
										fontWeight: 400
									} : {marginLeft: "8px"}} className={"bar-text"}>{item.node.choice}</span>
								</MDBProgress>
								<div className="poll-percentage my-2  mb-0">
									{/*<FlipAnimation value={item.node.choicePercentage} color={"#ffffff"} pixel={12}/>*/}
									{/*<p className={"mb-0"}>%</p>*/}
									{isNanHandler(item.node.choicePercentage)}%
								</div>
							</MDBBox>
						);
					})
				}
			</MDBBox>
		);
	}
}

class PollList extends React.Component {
	submitPollAns = (item,poll_id) => {
		if(this.props.logged_in){
			this.props.handleSelectedPolls(item, this.props.poll_result.id);
		} else {
			this.props.openLoginModal();
		}
	}
	render() {
		return (
			<MDBBox className="poll-list">
				{
					this.props.poll_result.pollChoices && this.props.poll_result.pollChoices.edges.map((item, index) => {
						return (
							<button key={index} className="btn w-100"
							        onClick={() => this.submitPollAns(item, this.props.poll_result.id)}>
								<img src={item.node.icon ? item.node.icon : BJP} alt="BJP" className="img-fluid"
								     width="20px" height={"20px"}/>
								<span className="poll-title">{item.node.choice}</span>
							</button>
						);
					})
				}
			</MDBBox>
		);
	}
}
